import { useState, useEffect } from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next';
function BudgetSuggestion({ refreshSignal }) {
  const [suggestion, setSuggestion] = useState({
    todayIncome: 0,
    todayExpense: 0,
    profit: 0,
    suggestedSpend: 0,
    message: ''
  })
const { t } = useTranslation();
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchSuggestion = () => {
    setLoading(true)
    const token = localStorage.getItem('token')
    axios
      .get('https://trakersmallbusienss-3.onrender.com/api/auth/suggestion/today', {
        headers: {
          Authorization: `Bearer ${token}`,
          'Cache-Control': 'no-cache'
        }
      })
      .then((res) => setSuggestion(res.data))
      .catch((err) => {
        console.error('Backend suggestion error:', err.message)
        setError("Failed to fetch today's suggestion.")
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    fetchSuggestion()
  }, [])

  // 🔄 Re-fetch when signal changes (e.g., from parent)
  useEffect(() => {
    if (refreshSignal !== undefined) {
      fetchSuggestion()
    }
  }, [refreshSignal])

  if (loading) {
    return <div className="text-blue-600">Loading budget suggestion...</div>
  }

  if (error) {
    return <div className="text-red-600">{error}</div>
  }

  const { todayIncome, todayExpense, profit, suggestedSpend, message } = suggestion

  // Dynamic color based on profit
  const profitColor =
    profit > 20 ? 'text-green-600' : profit > 0 ? 'text-yellow-600' : 'text-red-600'

  return (
     <div className="card p-4 rounded-lg shadow-md bg-white dark:bg-gray-800">
      <h3 className="text-xl font-semibold text-gray-800 dark:text-white mb-4">
        💡 {t('suggestionCard.title')}
      </h3>

      {/* Suggestion Box */}
      <div className="bg-blue-50 dark:bg-blue-900/20 p-4 rounded-md mb-4">
        <h4 className="text-blue-800 dark:text-blue-300 font-medium mb-1">
          {t('suggestionCard.suggestionTitle')}
        </h4>
        <p className="text-2xl font-bold text-blue-700 dark:text-blue-400">
          €{parseFloat(suggestedSpend).toFixed(2)}
        </p>
        <p className="text-sm text-blue-600 dark:text-blue-400 mt-1">{message}</p>
      </div>

      {/* Summary Section */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-sm font-medium">
        <div className="bg-green-50 dark:bg-green-900/20 p-3 rounded-md text-green-800 dark:text-green-300">
          <p>🟢 {t('suggestionCard.earnings')}</p>
          <p className="text-lg font-bold">€{parseFloat(todayIncome).toFixed(2)}</p>
        </div>

        <div className="bg-red-50 dark:bg-red-900/20 p-3 rounded-md text-red-800 dark:text-red-300">
          <p>🔴 {t('suggestionCard.expenses')}</p>
          <p className="text-lg font-bold">€{parseFloat(todayExpense).toFixed(2)}</p>
        </div>

        <div className="bg-yellow-50 dark:bg-yellow-900/20 p-3 rounded-md">
          <p className={`font-medium ${profitColor}`}>💰 {t('suggestionCard.profit')}</p>
          <p className={`text-lg font-bold ${profitColor}`}>€{parseFloat(profit).toFixed(2)}</p>
        </div>
      </div>

      {/* Tips Section */}
      <div className="bg-yellow-50 dark:bg-yellow-900/20 p-3 rounded-md mt-5">
        <h4 className="text-sm font-medium text-yellow-800 dark:text-yellow-300 flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" viewBox="0 0 20 20" fill="currentColor">
            <path
              fillRule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
              clipRule="evenodd"
            />
          </svg>
          {t('suggestionCard.tips.title')}
        </h4>
        <ul className="text-sm text-yellow-700 dark:text-yellow-400 mt-1 space-y-1 pl-5 list-disc">
          <li>{t('suggestionCard.tips.tip1')}</li>
          <li>{profit > 0 ? t('suggestionCard.tips.tip2_profit') : t('suggestionCard.tips.tip2_noProfit')}</li>
          <li>{t('suggestionCard.tips.tip3')}</li>
        </ul>
      </div>
    </div>
  )
}

export default BudgetSuggestion
